export default __webpack_public_path__ + "static/media/Frame3.00dffbb4.png";